import { Injectable } from '@angular/core';
import { EndUserViewsPermissionsDto } from '@osos/shared/api';
import { DataViewsPermissionsForEndUserPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class DataViewsPermissionsForEndUserParserV1Service extends ParserBase<
  EndUserViewsPermissionsDto,
  DataViewsPermissionsForEndUserPresenterModel
> {
  constructor() {
    super(
      EndUserViewsPermissionsDto,
      DataViewsPermissionsForEndUserPresenterModel,
      1,
    );
  }

  getPresenterModel(
    model: EndUserViewsPermissionsDto,
  ): DataViewsPermissionsForEndUserPresenterModel {
    const presenter = {
      isAuthenticated: model.isAuthenticated,
      isRestricted: model.isRestricted,
      permissions: model.permissions,
    } as DataViewsPermissionsForEndUserPresenterModel;
    return presenter;
  }

  getDataModel(
    presenter: DataViewsPermissionsForEndUserPresenterModel,
  ): EndUserViewsPermissionsDto {
    const model = {
      isAuthenticated: presenter.isAuthenticated,
      isRestricted: presenter.isRestricted,
      permissions: presenter.permissions,
    } as EndUserViewsPermissionsDto;

    return model;
  }
}
